// extracted by mini-css-extract-plugin
export default {"stat":"Github_stat__svpnn","one":"Github_one__4XtRZ","two":"Github_two__PCIba","three":"Github_three__ExdG5"};